export default __webpack_public_path__ + "247fcd35fe4d9141ee9e5644fee13226.jpeg";